import { useState } from 'react'
import { useSession } from 'next-auth/react'

import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

import errorMsg from '../../../Functions/errorMsg'
import successMsg from '../../../Functions/successMsg';

import axios from 'axios';

import PolicyPage from '../../../Home/Policies/Policies';

import MapWithRadius from '../../../Misc/MapWithRadius/MapWithRadius';
import MapWithLocation from '../../../Misc/MapWithLocation/MapWithLocation';

import GeneralEvent from './GeneralEvent/GeneralEvent'; 

import Resizer from 'react-image-file-resizer'
import SolarEclipseMap from '../../../Misc/SolarEclipseMap/SolarEclipseMap';

export default function CreateEvent({ setNavCategory }) {

    const { data: session, status } = useSession();

    const [policyPage, showPolicyPage] = useState(false);

    const [categoryType, setCategoryType] = useState(null);

    const [mapType, setMapType] = useState(null);

    /* Handle Listing Create Upload */

    const [pendingRequest, setPendingRequest] = useState(false);

    async function handleCreateListing(data) {
        if(pendingRequest === true) return;
        if(data === null) return errorMsg("We ran into an issue creating your post, please contact us if the issue persists.");
        if(!session || status !== 'authenticated') return errorMsg("You're not authenticated to create a post, please re-login.");
        if(typeof window === 'undefined') return;
        const heic2any = require('heic2any');

        setPendingRequest(true);

        const resizeImages = await Promise.all(
          data.toUpload.map(async (image, index) => {
            try {
              var fileSize = (image.imageFile.size / (1024 * 1024)).toFixed(2);
              if (fileSize > 8) {
                errorMsg("Image is too large, images can be no bigger than 8mb");
                return;
              }
        
              let resizedImage;
              if (image.imageFile.name.includes('.HEIC')) {
                const jpegBlob = await heic2any({ blob: image.imageFile, toType: 'image/jpeg' });
                resizedImage = await resizeFile(jpegBlob);
              } else {
                resizedImage = await resizeFile(image.imageFile);
              }
        
              return { position: index + 1, image: resizedImage };
            } catch (error) {
              console.error("Error resizing image:", error);
              errorMsg("We could not upload your image, please try again later or contact us");
              setPendingRequest(false);
              return;
            }
          })
        ).catch(() => {
          errorMsg("We could not upload your image, please try again later or contact us");
          setPendingRequest(false);
          return;
        });

        var manipulatedData = {...data};
        manipulatedData.images = resizeImages;
        delete manipulatedData.toUpload;

        const apiResult = await axios.post(`${window.location.origin}/api/eventHub/createEventListing`, {
          requestingUserID: session.user.token.id,
          eventData: manipulatedData
        }).catch((error) => { 
            errorMsg(error?.response?.data?.status || error.toString());
            setPendingRequest(false);
        });
      
        if(apiResult && apiResult.status === 200) {
            setNavCategory("My Events");
            successMsg("Your listing is currently under review.");
            setPendingRequest(false);
        }

    }

    const resizeFile = (file) =>
    new Promise((resolve, reject) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        "PNG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        200,
        200
      );
    });

    /* END HANDLE LISTING UPLOAD */

    /* Handle Image Data Here */

    /* ==== End Handle Image Data ===== */

    function handleBack() {
        setCategoryType(null);
        setMapType(null);
    }

  return (
    <section id={styles.wrapper}>

        { policyPage === true && <section id={styles.policyContainer}> <FontAwesomeIcon onClick={() => showPolicyPage(false)} icon={faXmarkCircle} id={styles.exitPolicy} /> <PolicyPage /> </section> }

        <div id={styles.form}>
            { categoryType === null && <SelectCategory setCategoryType={setCategoryType} /> }
            { categoryType === 'General Event' && <GeneralEvent setMapType={setMapType} handleBack={handleBack} showPolicyPage={showPolicyPage} pendingRequest={pendingRequest} handleCreateListing={handleCreateListing} /> }
        </div>
        <div id={styles.interactiveMap}>
            
            { (mapType !== null && mapType.type === 'ZIP' ) && <MapWithRadius zipCode={mapType.zip} /> }
            { (mapType !== null && mapType.type === 'Location' && categoryType !== 'Solar Eclipse' ) && <MapWithLocation address={mapType.address} city={mapType.city} zipCode={mapType.zip} /> }
            { (mapType !== null && mapType.type === 'Location' && categoryType === 'Solar Eclipse') && <SolarEclipseMap address={mapType.address} city={mapType.city} zipCode={mapType.zip} /> }
            { mapType === null && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }

        </div>
    </section>
  )
}

const SelectCategory = ({ setCategoryType }) => {

  return (
    <div id={styles.enterCategory}>
        <h1>What kind of event are you posting?</h1>
        <section>
            <button onClick={() => setCategoryType('General Event')}>General Event</button>
        </section>
    </div>
  )
}